import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import { NotificationProvider } from './context/NotificationContext'
import { ServerHealthProvider } from './context/ServerHealthContext'
import './styles/globals.css'

// Auto theme switching based on time
// Dark: 6pm (18:00) to 7am (07:00)
// Light: 7am (07:00) to 6pm (18:00)
function getThemeByTime() {
  const hour = new Date().getHours()
  // Light mode: 7am to 6pm (7-17)
  // Dark mode: 6pm to 7am (18-6)
  if (hour >= 7 && hour < 18) {
    return 'light'
  }
  return 'dark'
}

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme)
  // Store in localStorage so it persists during session
  localStorage.setItem('redstone-theme', theme)
  localStorage.setItem('redstone-theme-auto', 'true')
}

function initTheme() {
  // Check if user has manually set a preference (not auto)
  const isAuto = localStorage.getItem('redstone-theme-auto') !== 'false'

  if (isAuto) {
    // Auto mode - apply theme based on time
    const theme = getThemeByTime()
    applyTheme(theme)
  } else {
    // Manual mode - use stored preference
    const storedTheme = localStorage.getItem('redstone-theme') || 'dark'
    document.documentElement.setAttribute('data-theme', storedTheme)
  }
}

// Initialize theme immediately
initTheme()

// Check theme every minute to auto-switch at boundaries
setInterval(() => {
  const isAuto = localStorage.getItem('redstone-theme-auto') !== 'false'
  if (isAuto) {
    const currentTheme = document.documentElement.getAttribute('data-theme')
    const newTheme = getThemeByTime()
    if (currentTheme !== newTheme) {
      applyTheme(newTheme)
    }
  }
}, 60000) // Check every minute

// Export theme utilities for use in components
window.themeUtils = {
  setTheme: (theme) => {
    localStorage.setItem('redstone-theme-auto', 'false')
    localStorage.setItem('redstone-theme', theme)
    document.documentElement.setAttribute('data-theme', theme)
  },
  setAutoTheme: () => {
    localStorage.setItem('redstone-theme-auto', 'true')
    applyTheme(getThemeByTime())
  },
  getTheme: () => document.documentElement.getAttribute('data-theme'),
  isAutoMode: () => localStorage.getItem('redstone-theme-auto') !== 'false'
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <ServerHealthProvider>
            <App />
          </ServerHealthProvider>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)